import type { Violation } from '../../api/client';

function one(v: Violation): string[] {
  const d = v.detail ?? {};
  switch (v.message) {
    case 'VoiceArtifactMustBeAudioError': return ['Файл должен быть аудиофайлом.'];
    case 'VoiceArtifactDurationUnrecognizedError': return ['Не удалось определить длительность аудио.'];
    case 'VoiceArtifactFormatUnrecognizedError': return ['Не удалось определить формат аудио.'];
    case 'VoiceArtifactUnsupportedFormatError': {
      const formats = Array.isArray(d.supported) ? d.supported.join(', ').toUpperCase() : '';
      return [`Неподдерживаемый формат${formats ? `. Доступно: ${formats}` : ''}.`];
    }
    case 'VoiceArtifactTooShortError': return [`Аудио слишком короткое. Минимум ${d.min_duration ?? '—'} сек.`];
    case 'VoiceArtifactTooLongError': return [`Аудио слишком длинное. Максимум ${d.max_duration ?? '—'} сек.`];
    case 'VoiceArtifactTooBigError': {
      const bytes = Number(d.max_size ?? 0);
      const mb = bytes ? Math.round(bytes / 1024 / 1024) : null;
      return [`Файл слишком большой${mb ? `. Максимум ${mb} МБ` : ''}.`];
    }
    case 'AggregatedVoiceArtifactError': {
      const nested = Array.isArray(d.errors) ? d.errors as Violation[] : [];
      return nested.flatMap(one);
    }
    default: return ['Не удалось проверить аудиофайл. Попробуйте другой файл.'];
  }
}

export function mapVoiceViolations(violations: Violation[]): string[] {
  return [...new Set(violations.flatMap(one))];
}
